module.exports = __webpack_public_path__ + "static/media/400142_01.0bd91fa9.png";